import ContentLoader from "react-content-loader";
import { merge } from "react-merge";
import { useMediaQuery } from "react-responsive";
import { Color } from "../../enums/Color";

const loaderStyle = {
  mobile : {
    width: "90.34vw",
    backgroundColor: Color.White, 
    padding: "0 2.13vw",
    zIndex: "1",
    height: "99.51vw"
  },
  desktop: {
    borderRadius: "0.52vw",
    width: "62.91vw",
    height: "50.83vw",
    marginLeft: "3.00vw",
    marginBottom: "-7.00vw" 
  }
};

export const OrganizationLoader : React.FC = () => {
  const isMobile = useMediaQuery ({ query : "(max-width: 786px)"});
  var styles = loaderStyle.mobile;
  if(!isMobile) {
    let extendedStyle = merge(loaderStyle.mobile, loaderStyle.desktop);
    styles = extendedStyle;
  }

  return(        
    <div style={styles}>
      <ContentLoader
        speed={1}
        backgroundColor={Color.LoaderBackground}
        foregroundColor={Color.LoaderForeground}
        width= "auto"
        height= {styles.height}
      > 
        {isMobile ? <>
          <rect x="4%" y="0" rx="3" ry="3" width="21.92%" height="5.58%" />
          <rect x="0" y="6.79%" rx="3" ry="3" width="100%" height="12.13%" />
          <rect x="4%" y="23.78%" rx="3" ry="3" width="22.92%" height="5.58%" />
          <rect x="0" y="30.58%" rx="3" ry="3" width="100%" height="12.13%" />
          <rect x="4%" y="45.28%" rx="3" ry="3" width="22.92%" height="5.58%" />
          <rect x="0" y="52.07%" rx="3" ry="3" width="100%" height="30.00%" />
          <rect x="4%" y="84.06%" rx="3" ry="3" width="22.92%" height="5.58%" />
          <rect x="0" y="91.67%" rx="3" ry="3" width="100%" height="12.13%" />
        </> : 
        <>
          <rect x="0" y="3%" rx="3" ry="3" width="25.33%" height="30.25%" />
          <rect x="34.25%" y="0" rx="3" ry="3" width="11.33%" height="3.25%" />
          <rect x="71.75%" y="0" rx="3" ry="3" width="11.33%" height="3.25%" />
          <rect x="33%" y="4%" rx="3" ry="3" width="31.01%" height="6.5%" />
          <rect x="70%" y="4%" rx="3" ry="3" width="31.01%" height="6.5%" />
          <rect x="34.25%" y="14.00%" rx="3" ry="3" width="11.33%" height="3.25%" />
          <rect x="33%" y="18%" rx="3" ry="3" width="100%" height="17.5%" />
          <rect x="0" y="37%" rx="3" ry="3" width="25.33%" height="6.5%" />
          <rect x="0" y="47%" rx="3" ry="3" width="25.33%" height="6.5%" />
          <rect x="0" y="57%" rx="3" ry="3" width="25.33%" height="6.5%" />
          <rect x="0" y="67%" rx="3" ry="3" width="25.33%" height="6.5%" />
          <rect x="34.25%" y="38%" rx="3" ry="3" width="11.33%" height="3.25%" />
          <rect x="71.75%" y="38%" rx="3" ry="3" width="11.33%" height="3.25%" />
          <rect x="33%" y="42%" rx="3" ry="3" width="31.01%" height="6.5%" />
          <rect x="70%" y="42%" rx="3" ry="3" width="31.01%" height="6.5%" />
          <rect x="34.25%" y="51%" rx="3" ry="3" width="11.33%" height="3.25%" />
          <rect x="33%" y="55%" rx="3" ry="3" width="100%" height="6.5%" />
          <rect x="34.25%" y="64%" rx="3" ry="3" width="11.33%" height="3.25%" />
          <rect x="33%" y="68%" rx="3" ry="3" width="100%" height="6.5%" />
          <rect x="34.25%" y="76%" rx="3" ry="3" width="11.33%" height="3.25%" />
          <rect x="33%" y="80%" rx="3" ry="3" width="100%" height="6.5%" />
          <rect x="34.25%" y="88%" rx="3" ry="3" width="11.33%" height="3.25%" />
          <rect x="33%" y="92%" rx="3" ry="3" width="100%" height="6.5%" />
        </>} 
      </ContentLoader>  
    </div>      
  )
}